<style>
  .multiselect.is-invalid .multiselect__tags {
    border-color: red !important;
  }
</style>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { format } from 'date-fns';
import { getFirebaseBackend } from '@/helpers/firebase/authUtils';
import Multiselect from "vue-multiselect";
import NumberInputSpinner from "vue-number-input-spinner";
import collect from 'collect.js';

import {
  required,
  // email,
  // minLength,
  // sameAs,
  // maxLength,
  // minValue,
  // maxValue,
  // numeric,
  // url,
  // alphaNum
} from "vuelidate/lib/validators";

export default {
    page: {
        title: "Permohonan",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, FormWizard, TabContent, Multiselect, NumberInputSpinner },
    data() {
        return {
          fileRequire: false,
          tajukFile: 'Choose file',
          uploadedFileName: null,
          simpan_msg: 'Tempahan berjaya',
          modal_simpan: false,
          bil_peserta: 1,
          submitted: false,
          tajuk_aktiviti: null,
            pkg: [],
            senaraiIventori: {},
            peralatan_mohon:[],
            peralatan_dimohon: {
              'LCD Projektor': 0,
              'Mikrobotik': 0,
              'Rekaedukit':0,
              '3D Printing':0,
              'Laptop Robotik/3D Printing':0
            },
            bilik_url: '',
            bilik_pilih: [],
            senaraiBilikPKG: [],
            senaraiSlotTempah: null,
            nama_pkg: 'PKG Bangsar',
            pkg_pilih: 'PKG_Bangsar',
            hariIniStr: format(new Date(),'yyyy-MM-dd'),
            title: "Mohon Tempahan",
            slot_pilih: [],
            slot: ["8:00 - 9:00","9:00 - 10:00","10:00 - 11:00","11:00 - 12:00","12:00 - 13:00",
                "13:00 - 14:00","14:00 - 15:00","15:00 - 16:00","16:00 - 17:00"    
                ],
            items: [
                {
                    text: "Home",
                    href: "/"
                },
                {
                    text: "Mohon",
                    active: true
                }
            ]
        };
    },
    validations: {
      bilik_pilih: { required },
      slot_pilih: { required },
      tajuk_aktiviti: { required },
    },
    watch: {
        pkg_pilih:function() {
            this.senaraiBilik()
            this.bilik_pilih = []
            const nama_pkg = collect(this.pkg).filter((value) => value.id == this.pkg_pilih).all()
            this.nama_pkg = nama_pkg[0]['nama']
        },
        hariIniStr:function() {
            this.senaraiBilik()
            this.bilik_pilih = []
        },
        bilik_pilih:function() {
            this.semakSlot()
            const url_bilik = collect(this.pkg).filter((value) => value.id == this.pkg_pilih).all()
            const bilik_satu = collect(url_bilik[0]['bilik']).filter((value) => value.nama == this.bilik_pilih).all()
            if (bilik_satu.length>0){
              this.bilik_url = bilik_satu[0]['url']
            }
            // this.$set(this.peralatan_dimohon, 'LCD Projektor', 0)
            // this.$set(this.peralatan_dimohon, 'Kit Robotik', 0)
            console.log("latest baku peralatan ->",this.peralatan_dimohon)
            this.tempahanByPKG()
            
        }
    },
    methods: {
      semakFileUpload() {
        let that = this
        that.fileRequire = true
        return new Promise((resolve, reject) => {
          if (that.$refs.fileUpload.files.length > 0) {
            that.fileRequire = false
            resolve(true)
          }
          reject('This value is required.')  
        })
      },
      fileNameChg() {
        this.tajukFile = "Choose files"
        let senarai_file = []
        for (var i = 0; i < this.$refs.fileUpload.files.length; i++ ) {
          // console.log('file note -> ',this.$refs.fileUpload.files[i].name)
          senarai_file.push(this.$refs.fileUpload.files[i].name)
        }
        if (senarai_file.length > 0) {
          this.tajukFile = senarai_file.join(', ')
        }
        this.semakFileUpload()
      },
      onComplete() {
        getFirebaseBackend().getTempahanPKG(this.hariIniStr.replace(/-/g,'/'),this.pkg_pilih).then((response) => {
            const allDoc = []
            response.forEach((doc) => {
                const doc_data = doc.data()
                doc_data['id'] = doc.id
                allDoc.push(doc_data)
            })
            return allDoc
        }).then((dt) => {
          this.senaraiSlotTempah = dt
            const that = this
            for (const [key, value] of Object.entries(that.senaraiIventori)) {

              that.senaraiIventori[key]['baki'] = value.unit
            }
            if (dt.length > 0) {
                this.peralatan_mohon = []
                collect(dt).flatMap(value => value.peralatan).each((itemP) => {
                  for (const [key, value] of Object.entries(itemP)) {
                    this.peralatan_mohon.push({'nama':key,'bil':value})
                  }
                })
                if (this.peralatan_mohon.length > 0) {
                  this.peralatan_mohon = collect(this.peralatan_mohon).groupBy('nama').all()
                  
                  for (const [key, value] of Object.entries(that.peralatan_mohon)) {
                    that.peralatan_mohon[key]['jumlah'] = collect(value.items).sum('bil')
                  }
                  for (const [key, value] of Object.entries(that.senaraiIventori)) {

                    that.senaraiIventori[key]['baki'] = value.unit - that.peralatan_mohon[key]['jumlah']
                    // that.peralatan_dimohon[key] = that.senaraiIventori[key]['baki']
                  }
                }
                this.senaraiSlotTempah = collect(dt).groupBy('bilik').all()
            }
            console.log('Slot Pilih',this.slot_pilih)
            let slot_take = true
            let cukup_inventori = true
            collect(this.slot_pilih).each((item) => {
              if (!this.slot.includes(item)) {
                slot_take = false
                return false
              }
            })
            console.log("this.peralatan_dimohon:",this.peralatan_dimohon)
            console.log("this.senaraiIventori:",this.senaraiIventori)
            for (const alat in this.peralatan_dimohon) {
              if (alat in this.senaraiIventori){
                if (this.peralatan_dimohon[alat] > this.senaraiIventori[alat]['baki']) {
                  cukup_inventori = false
                  break
                }
              }
              // if (this.peralatan_dimohon[alat] > this.senaraiIventori[alat]['baki']) {
              //   cukup_inventori = false
              //   break
              // }
              // console.log('pilihan iventori',alat,':',this.peralatan_dimohon[alat])
            }
            console.log("slot cukup:",slot_take)
            console.log("inveroti cukup:",cukup_inventori)
            if (slot_take && cukup_inventori) {
              let myMemo = []
              let fileupload = []
              for (var i = 0; i < this.$refs.fileUpload.files.length; i++ ) {
                myMemo.push(this.$refs.fileUpload.files[i])
              }
              // uploadMemos
              Promise.all(
                // Array of "Promises"
                myMemo.map(item => getFirebaseBackend().uploadMemos(item).then((response) => {
                    console.log('upload:',response)
                }))
              )
              .then(() => {
                Promise.all(
                  // Array of "Promises"
                  myMemo.map(item => getFirebaseBackend().urlMemos(item).then((response) => {
                      console.log('url:',response)
                      let fu = {'file':item.name,'url':response}
                      fileupload.push(fu)
                  }))
                )
                .then(() => {
                  const user_detail = JSON.parse(sessionStorage.getItem('user_detail'))
                  let data_inser = {
                    bilik: this.bilik_pilih,
                    url: this.bilik_url,
                    files: fileupload,
                    pemohon: this.$store.state.auth.currentUser.email,
                    fullname: user_detail.fullname,
                    phone_no: user_detail.phone_no,
                    sekolah_ppd: user_detail.sekolah_ppd,
                    sektor: user_detail.sektor,
                    tajuk: this.tajuk_aktiviti,
                    status_permohonan: "Semakan",
                    bil_peserta: this.bil_peserta,
                    peralatan:this.peralatan_dimohon,
                    pkg: this.nama_pkg,
                    pkg_id:this.pkg_pilih,
                    slot:this.slot_pilih,
                    tarikh:this.hariIniStr.replace(/-/g,'/')

                  }
                  console.log('fileupload:',data_inser)
                  getFirebaseBackend().insertTempahan(data_inser).then(() => {
                    // that.peralatan_dimohon = {
                    //   'LCD Projektor': 0,
                    //   'Kit Robotik':0
                    // },
                    this.modal_simpan = true
                    this.simpan_msg = 'Tempahan berjaya'
                    that.$router.push({ path: '/senarai' })
                  })
                  .catch((error) => {
                    this.modal_simpan = false
                    this.simpan_msg = 'Tempahan tidak berjaya. Err:' + error
                  });
                })
                .catch((error) => {
                  this.modal_simpan = false
                  this.simpan_msg = 'Tempahan tidak berjaya. Err:' + error
                });
              })
              .catch((error) => {
                this.modal_simpan = false
                this.simpan_msg = 'Tempahan tidak berjaya. Err:' + error
              });
            }

        })

      },
      validateBilik() {
        this.$v.bilik_pilih.$touch();
        return new Promise((resolve, reject) => {
          if (this.$v.bilik_pilih.$error) {
            reject('This value is required.')
          }
          else {
            resolve(true)  
          }
        })
      },
      validateSlot() {
        this.$v.slot_pilih.$touch();
        this.$v.tajuk_aktiviti.$touch();
        return new Promise((resolve, reject) => {
          if (this.$v.slot_pilih.$error || this.$v.tajuk_aktiviti.$error) {
            reject('This value is required.')
          }
          else {
            resolve(true)  
          }
        })
      },
        semakSlot() {
            // console.log("pilihan Bilik -> ",val)
            if (this.senaraiSlotTempah.length === undefined) {
                const slot_sedia_ada = collect(this.senaraiSlotTempah[this.bilik_pilih]).flatMap(value => value.slot).all()
                this.slot = collect(this.slot).diff(slot_sedia_ada).all()
                console.log('Slot Bilik -> ',slot_sedia_ada)
                console.log('Slot Bilik Berbaki -> ',this.slot)

            }
            else {
                console.log('Size Slot Bilik -> ',this.senaraiSlotTempah.length)
            }
            
        },
    tempahanByPKG() {
        getFirebaseBackend().getTempahanPKG(this.hariIniStr.replace(/-/g,'/'),this.pkg_pilih).then((response) => {
            const allDoc = []
            response.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const doc_data = doc.data()
                doc_data['id'] = doc.id
                // doc_data['radio'] = "radio_pkg_" + doc.id
                allDoc.push(doc_data)
            })
            if (allDoc.length > 0) {
                // this.is_tempahah = false
            }
            return allDoc
        }).then((dt) => {
            // this.pkg = dt
            this.senaraiSlotTempah = dt
            const that = this
            for (const [key, value] of Object.entries(that.senaraiIventori)) {

              that.senaraiIventori[key]['baki'] = value.unit
              // console.log(key," -> ","lala -> ",collect(value.items).sum('bil'))
            }
            if (dt.length > 0) {
                this.peralatan_mohon = []
                collect(dt).flatMap(value => value.peralatan).each((itemP) => {
                  for (const [key, value] of Object.entries(itemP)) {
                    this.peralatan_mohon.push({'nama':key,'bil':value})
                  }
                })
                if (this.peralatan_mohon.length > 0) {
                  this.peralatan_mohon = collect(this.peralatan_mohon).groupBy('nama').all()
                  
                  for (const [key, value] of Object.entries(that.peralatan_mohon)) {
                    that.peralatan_mohon[key]['jumlah'] = collect(value.items).sum('bil')
                    // console.log(key," -> ","lala -> ",collect(value.items).sum('bil'))
                  }
                  for (const [key, value] of Object.entries(that.senaraiIventori)) {

                    that.senaraiIventori[key]['baki'] = value.unit - that.peralatan_mohon[key]['jumlah']
                    // that.peralatan_dimohon[key] = that.senaraiIventori[key]['baki']
                    // console.log(key," -> ","lala -> ",collect(value.items).sum('bil'))
                  }
                  console.log("Groupkan peralatan mohon -> ",(this.peralatan_mohon))
                  console.log("Baki Groupkan peralatan mohon -> ",(this.senaraiIventori))

                }
                console.log("Peralatan Mohon:",collect(dt).flatMap(value => value.peralatan).all())
                console.log("each peralatan:",this.peralatan_mohon)
                this.senaraiSlotTempah = collect(dt).groupBy('bilik').all()
            }
            console.log('PKG n tarikh -> ',this.senaraiSlotTempah)
        })

    },
    senaraiBilik() {
       this.senaraiIventori = {}
        // console.log("asal pkg pilih",this.pkg_pilih)
        const bilik = collect(this.pkg).filter((value) => value.id == this.pkg_pilih).all()
        this.senaraiBilikPKG = collect(bilik[0].bilik).flatMap(value => value.nama).all()
        this.senaraiIventori = collect(bilik[0].iventori).keyBy('nama').all()
        console.log('senarai bilik:',this.senaraiBilikPKG)
        console.log('this.pkg:',this.pkg)
        console.log('this bilik:',this.senaraiIventori)


        this.tempahanByPKG()
    },
    senaraiPKG() {
      getFirebaseBackend().getPKG().then((response) => {
        const allDoc = []
        response.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              const doc_data = doc.data()
              doc_data['id'] = doc.id
              doc_data['radio'] = "radio_pkg_" + doc.id
              allDoc.push(doc_data)
          })
          if (allDoc.length > 0) {
            // this.is_tempahah = false
          }
          return allDoc
      }).then((dt) => {
        this.pkg = dt
        // console.log("PKG:",collect(this.pkg).groupBy('id').all())
        this.senaraiBilik()
        // this.pkg =  collect(dt).groupBy('pkg').map(item => item.chunk(3)).all()
        // v-for="(chuck_inti,chuck_inti_i) in collect(p).chuck(3).all()" v-bind:key="chuck_inti_i
        // console.log("List => haha,",collect(this.tempah).groupBy('pkg').all())
      })
    }
  },
  mounted() {
    this.senaraiPKG()
    // this.peralatan_dimohon = {
    //   'LCD Projektor': 0,
    //   'Kit Robotik':0
    // },
    // this.senaraiBilik()
    // this.bilik_pilih = []
    console.log("user:",this.$store.state.auth.currentUser)
    // this.senaraiTempahan(this.hariIniStr.replace(/-/g,'/'))
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <b-modal no-close-on-backdrop v-model="modal_simpan"
        id="modal-backdrop"
        title="Static backdrop"
        title-class="font-18"
      >
        <p>{{ simpan_msg }}</p>
      </b-modal>
      <div class="col">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Tempahan Bilik</h4>
            <form-wizard color="#556ee6" @on-complete="onComplete">
              <tab-content icon="mdi mdi-calendar-month">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="date">Tarikh</label>
                      <div class="col-md-9">
                        <input
                          id="date"
                          type="date"
                          class="form-control"
                          v-model="hariIniStr"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <tab-content icon="mdi mdi-crosshairs-gps">
                <div class="row">
                  <div class="col-12">
                    <div>
                        <!-- {{ pkg }} -->
                        <h5 class="font-size-14 mb-4">PKG</h5>
                        <div class="form-check mb-3" v-for="p in pkg" v-bind:key="p.id">
                            <input
                            class="form-check-input"
                            type="radio"
                            name="exampleRadios"
                            :id="p.radio"
                            v-model="pkg_pilih"
                            v-bind:value="p.id"
                            />
                            <label class="form-check-label" :for="p.radio">{{ p.nama }}</label>
                        </div>
                        </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <tab-content icon="mdi mdi-google-classroom" :before-change="validateBilik">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="validationBilik" class="col-md-3 col-form-label">Bilik</label>
                      <div class="col-md-9">
                        <multiselect id="validationBilik" :class="{ 'is-invalid': $v.bilik_pilih.$error }" v-model="bilik_pilih" :options="senaraiBilikPKG" :multiple="false"></multiselect>
                        <div v-if="$v.bilik_pilih.$error" class="invalid-feedback">
                          <span v-if="!$v.bilik_pilih.required">This value is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tab-content>
              <tab-content icon="mdi mdi-account-clock-outline" :before-change="validateSlot">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="validationSlot" class="col-md-3 col-form-label">Slot Masa</label>
                      <div class="col-md-9">
                        <multiselect id="validationSlot" :class="{ 'is-invalid': $v.slot_pilih.$error }" v-model="slot_pilih" :options="slot" :multiple="true"></multiselect>
                        <div v-if="$v.slot_pilih.$error" class="invalid-feedback">
                          <span v-if="!$v.slot_pilih.required">This value is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-md-3 col-form-label">Tajuk/Aktiviti</label>
                      <div class="col-md-9">
                        <b-form-input placeholder="Masukkan tajuk/aktiviti" :class="{ 'is-invalid': $v.tajuk_aktiviti.$error }" v-model="tajuk_aktiviti"></b-form-input>
                        <div v-if="$v.tajuk_aktiviti.$error" class="invalid-feedback">
                          <span v-if="!$v.tajuk_aktiviti.required">This value is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-md-3 col-form-label">Bil. Peserta</label>
                      <div class="col-md-9">
                        <NumberInputSpinner :min="1" :max="40" :integerOnly="true" v-model="bil_peserta" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-for="(alat,alat_key,idx) in senaraiIventori" v-bind:key="idx">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-md-3 col-form-label">{{ alat_key }}, baki = {{ alat.baki - peralatan_dimohon[alat_key] }}</label>
                      <div class="col-md-9">
                        <NumberInputSpinner :min="0" :max="alat.baki" :integerOnly="true" v-model="peralatan_dimohon[alat_key]" />
                      </div>
                    </div>
                  </div>
                </div>
              </tab-content>
              <tab-content icon="mdi mdi-cloud-upload-outline" :before-change='semakFileUpload'>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Surat/Memo</h4>
                    <div class="custom-file">
                      <input id="customFile" :class="{ 'is-invalid': fileRequire }" ref="fileUpload" type="file" @change="fileNameChg" class="custom-file-input" multiple="true" />
                      <label class="custom-file-label" for="customFile"> {{ tajukFile }}</label>
                    </div>
                    <div v-if="fileRequire" class="is-invalid">
                      <span>This value is required.</span>
                    </div>
                  </div>
                </div>
              </tab-content>
            </form-wizard>
          </div>
          <!-- end card-body -->
        </div>
      </div>
    </div>
</Layout>
</template>